/* eslint-disable @typescript-eslint/naming-convention */

import {
  RegionAPIResult,
  GeoLocationService,
} from '../services/geolocation.service';
import { KEYS } from './constants/storage.constants';

export enum ErrorEvents {
  //Events for Developers
  TABS_FETCH_ERROR = 'TABS_FETCH_ERROR',
  COLLECTION_FETCH_ERROR = 'COLLECTION_FETCH_ERROR',
  CONTAINER_FETCH_ERROR = 'CONTAINER_FETCH_ERROR',
  RESOURCE_FETCH_ERROR = 'RESOURCE_FETCH_ERROR',
  SERIES_FETCH_ERROR = 'SERIES_FETCH_ERROR',
  EPISODES_FETCH_ERROR = 'EPISODES_FETCH_ERROR',
  SEARCH_FETCH_ERROR = 'SEARCH_FETCH_ERROR',
  RELATED_FETCH_ERROR = 'RELATED_FETCH_ERROR',
  UPNEXT_FETCH_ERROR = 'UPNEXT_FETCH_ERROR',
  PLAYBACK_ERROR = 'PLAYBACK_ERROR',
  DEVICE_REGISTRATION_ERROR = 'DEVICE_REGISTRATION_ERROR',
  SESSION_ERROR = 'SESSION_ERROR',
  ENTITLEMENTS_ERROR = 'ENTITLEMENTS_FETCH_ERROR',
  GENERAL_ERROR = 'ERROR',
  ADD_WATCHLIST_ERROR = 'ADD_WATCHLIST_ERROR',
  REMOVE_WATCHLIST_ERROR = 'REMOVE_WATCHLIST_ERROR',
  BOOKMARK_FETCH_ERROR = 'BOOKMARK_FETCH_ERROR',
  FAVORITE_FETCH_ERROR = 'FAVORITE_FETCH_ERROR',
  RENTALS_FETCH_ERROR = 'RENTALS_FETCH_ERROR',
  STOREFRONT_FETCH_ERROR = 'STOREFRONT_FETCH_ERROR',
  VOD_ENTITLEMENTS_ERROR = 'VOD_ENTITLEMENTS_ERROR',
}

export const getErrorData = (
  error: any,
  errorType?: any,
  errorCode?: any,
  errorMessage?: any
): any => {
  let errorAttributes: any = {};

  if (errorType) {
    errorAttributes.errorType = errorType;
  }
  if (error) {
    errorAttributes.errorCode = errorCode || error.errorCode;
    errorAttributes = {
      ...errorAttributes,
      ...getErrorMessage(error, errorMessage),
    };
    errorAttributes.code = error?.code;
    if (error.AddSubscriptionResponseMessage) {
      errorAttributes.errorCode = errorCode(error);
    }
    errorAttributes.productId = error?.productId;
    errorAttributes.domain = error?.domain;
    errorAttributes.description = error?.desc;
    errorAttributes.debugMessage = error?.debugMessage;
    errorAttributes.message = error?.message;
    errorAttributes.productId = error?.productId;
    errorAttributes.responseCode = error?.responseCode;

    errorAttributes.errorCode = error?.hexErrorCode;
    const errorDescritpion = getErrorDescription(error);
    errorAttributes.errorDescription = errorDescritpion;
    const internalErrorObjt = getInternalError(error);
    if (internalErrorObjt) {
      errorAttributes = { ...errorAttributes, ...internalErrorObjt };
    }
  }
  return errorAttributes;
};

const getErrorMessage = (error: any, errorMessage: any): any => {
  if (error?.errorMessage) {
    return {
      errorMessage: error.errorMessage,
      errorDescription: errorMessage ? errorMessage : error.errorMessage,
    };
  }
};

const getErrorDescription = (error: any): any => {
  if (error?.contextDescription) {
    return error.contextDescription;
  } else if (error?.errorDescription) {
    return error.errorDescription;
  }
  return undefined;
};

const getInternalError = (error: any): any => {
  if (error.internalError) {
    return {
      internalError: error.internalError?.errorCode,
      errorDescription: error.internalError,
    };
  } else if (error.errorMessage && error.errorCode) {
    return {
      errorDescritpion: error,
    };
  }
  return undefined;
};

export const getRegionError = (
  geoLocationService: GeoLocationService
): { isError: boolean; errorMessage: string } => {
  const location = JSON.parse(
    localStorage.getItem(KEYS.LOCATION) || '{}'
  ) as RegionAPIResult;
  const channel = geoLocationService.getChannel(location)?.toUpperCase();
  const accountChannelPartnerID = sessionStorage
    .getItem('accountChannelPartnerID')
    ?.toUpperCase();
  const displayLanguage = localStorage.getItem(KEYS.DISPLAY_LANGUAGE);
  const isError =
    accountChannelPartnerID !== channel &&
    accountChannelPartnerID !== null &&
    accountChannelPartnerID !== undefined;
  let errorMessage = '';
  if (displayLanguage === 'tg') {
    errorMessage = `ప్రస్తుతం ఉన్న మీ అకౌంట్ కేవలం రిజిస్టర్డ్ ఏరియా పరిధిలోనే పనిచేస్తుంది మరియు చెల్లుబాటు అవుతుంది. మరో కొత్త రీజియన్ లో ఆహాను యాక్సెస్ చేసుకోదలిచినవారు ఈ కింది విధానాన్ని పాటించండి.\n1. ప్రస్తుత అకౌంట్ నుంచి లాగౌట్ అయ్యి మరో కొత్త ఇమెయిల్ ఐడీతో ఆహాను యాక్సెస్ చేయండి\n2. లోకల్ కరెన్సీ ప్రకారం అందుబాటులో ఉన్న సబ్ స్క్రిప్షన్ ప్లాన్ ను ఎంచుకోండి\n3. లావాదేవిని పూర్తి చేయండి.`;
  } else if (displayLanguage === 'tm') {
    errorMessage =
      'உங்கள் தற்போதைய கணக்கு செல்லுபடியாகும் மற்றும் பதிவுசெய்யப்பட்ட பகுதியில் மட்டுமே செயலில் உள்ளது. புதிய பிராந்தியத்தில் ஆஹாவை அணுக:\n1. ஆஹாவை அணுக, வெளியேறி வெவ்வேறு மின்னஞ்சல் ஐடியுடன் பதிவு செய்யவும்\n2. கிடைக்கக்கூடிய உள்ளூர் நாணயத் திட்டத்தைத் தேர்ந்தெடுக்கவும்\n3. பரிவர்த்தனையை முடிக்கவும்.';
  } else {
    errorMessage = `Your existing account is valid and active only in the registered region. To access aha in a new region:\n1. Logout and register with different email ID to access aha\n2. Select a local currency plan available.\n3. Complete the transaction.`;
  }
  return {
    isError,
    errorMessage,
  };
};
